/* eslint-disable import/prefer-default-export */
export const getChatsSelector = state => state.chats.list;
export const getActiveChatSelector = state => state.chats.current;
export const getChatMessages = state => state.chats.messages;
export const getChatNotifications = state => state.chats.notifications;
